// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"letters-c"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M16 19H9C8.44772 19 8 18.5523 8 18V6C8 5.44772 8.44772 5 9 5H16","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-letters-c')
export default class LettersCIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'letters-c',
    }
  }
}
